import { render, staticRenderFns } from "./orderTcCgApprove.vue?vue&type=template&id=eee619ac&scoped=true"
import script from "./orderTcCgApprove.vue?vue&type=script&lang=js"
export * from "./orderTcCgApprove.vue?vue&type=script&lang=js"
import style0 from "./orderTcCgApprove.vue?vue&type=style&index=0&id=eee619ac&prod&scoped=true&lang=css"
import style1 from "./orderTcCgApprove.vue?vue&type=style&index=1&id=eee619ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee619ac",
  null
  
)

export default component.exports